import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
export function ErrorFallback({ error }) {
    const { t } = useTranslation();
    return (_jsxs("div", { role: "alert", children: [_jsx("p", { children: t('Something went wrong') }), _jsx("pre", { style: { color: 'red' }, children: error.message })] }));
}
